export function loadSynerise() {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="synerise-tracker-key"]');
  const trackerKey = meta?.content;

  if (!trackerKey) {
    console.error("[synerise] Tracker key not found in meta tag");
    return;
  }

  if (window.SR?.init || window.onSyneriseLoad) {
    return;
  }

  window.onSyneriseLoad = () => {
    if (window.SR) {
      window.SR.init({
        trackerKey,
        dataLayer: window.dataLayer,
        dntCookieName: "_snrs_dnt",
      });
    }
  };

  ((s, y, n, e, r, i) => {
    s["SyneriseObjectNamespace"] = r;
    // @ts-expect-error - Synerise snippet
    s[r] = s[r] || [];
    // @ts-expect-error - Synerise snippet
    s[r]._t = 1 * new Date();
    // @ts-expect-error - Synerise snippet
    s[r]._i = 0;
    // @ts-expect-error - Synerise snippet
    s[r]._l = i;
    const z = y.createElement(n) as HTMLScriptElement;
    const se = y.getElementsByTagName(n)[0];
    z.async = true;
    z.src = e;
    if (se?.parentNode) {
      se.parentNode.insertBefore(z, se);
    } else {
      (y.head ?? y.body ?? y.documentElement).appendChild(z);
    }
    z.onload = () => {
      const rdy = z.readyState;
      if (!rdy || /complete|loaded/.test(z.readyState)) {
        // @ts-expect-error - Synerise snippet
        s[i]();
        z.onload = null;
        // @ts-expect-error - Synerise snippet
        z.onreadystatechange = null;
      }
    };
    // @ts-expect-error - Synerise snippet
  })(window, document, "script", "//web.snrbox.com/synerise-javascript-sdk.min.js", "SR", "onSyneriseLoad");
}
